import {
  GET_TICKETS,
  GET_DETAIL,
  SET_LOADING,
  GET_REFERENCE_DATA,
  ADD_TICKET_RESPONSE,
} from '../types/ticket';

export function getTickets(params) {
  return {
    type: GET_TICKETS,
    params,
  };
}

export function getTicketDetail(id) {
  return { type: GET_DETAIL, id };
}

export function setLoading(isLoading = false) {
  return { type: SET_LOADING, isLoading };
}

export function addTicketResponse(payload, callback) {
  return { type: ADD_TICKET_RESPONSE, payload, callback };
}

export function getReferenceData(params) {
  return {
    type: GET_REFERENCE_DATA,
    params,
  };
}
